import {
  BENEFICIAL_OWNER_DATE_OF_BIRTH,
  BENEFICIAL_OWNER_NATIONALITY,
  BENEFICIAL_OWNER_ADDITIONAL_NATIONALITIES,
  BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PASSPORT_DOCUMENT,
  COMPANY_LEGAL_REPRESENTATIVES,
  BENEFICIAL_OWNER_COUNTRY_OF_BIRTH,
  COMPANY_DIRECTORS,
  COMPANY_ULTIMATE_BENEFICIAL_OWNERS,
  LEGAL_REPRESENTATIVE_DATE_OF_BIRTH,
  LEGAL_REPRESENTATIVE_EMAIL_ADDRESS,
  LEGAL_REPRESENTATIVE_NATIONALITY,
  LEGAL_REPRESENTATIVE_COUNTRY_OF_BIRTH,
  LEGAL_REPRESENTATIVE_ADDITIONAL_NATIONALITIES,
  LEGAL_REPRESENTATIVE_PASSPORT_DOCUMENT,
  DIRECTOR_DATE_OF_BIRTH,
  DIRECTOR_EMAIL_ADDRESS,
  DIRECTOR_NATIONALITY,
  DIRECTOR_ADDITIONAL_NATIONALITIES,
  DIRECTOR_COUNTRY_OF_BIRTH,
  DIRECTOR_PASSPORT_DOCUMENT,
} from '@modifi/plugin-onboarding'

export const ADDRESS_NATIONALITY = 'NATIONALITY'
export const ADDRESS_DATE_OF_BIRTH = 'DATE_OF_BIRTH'
export const ADDRESS_ADDITIONAL_NATIONALITIES = 'ADDITIONAL_NATIONALITIES'
export const ADDRESS_COUNTRY_OF_BIRTH = 'COUNTRY_OF_BIRTH'
export const ADDRESS_EMAIL = 'EMAIL'
export const PASSPORT_DOCUMENT = 'PASSPORT_DOCUMENT'

export const FORM_TYPE_TO_INPUT_FIELD_MAPPING: Record<string, any> = {
  [COMPANY_LEGAL_REPRESENTATIVES]: {
    _type: 'PERSON_ADDRESS',
    [ADDRESS_NATIONALITY]: LEGAL_REPRESENTATIVE_NATIONALITY,
    [ADDRESS_DATE_OF_BIRTH]: LEGAL_REPRESENTATIVE_DATE_OF_BIRTH,
    [ADDRESS_EMAIL]: LEGAL_REPRESENTATIVE_EMAIL_ADDRESS,
    [ADDRESS_ADDITIONAL_NATIONALITIES]: LEGAL_REPRESENTATIVE_ADDITIONAL_NATIONALITIES,
    [ADDRESS_COUNTRY_OF_BIRTH]: LEGAL_REPRESENTATIVE_COUNTRY_OF_BIRTH,
    [PASSPORT_DOCUMENT]: LEGAL_REPRESENTATIVE_PASSPORT_DOCUMENT,
  },
  [COMPANY_DIRECTORS]: {
    _type: 'PERSON_ADDRESS',
    [ADDRESS_NATIONALITY]: DIRECTOR_NATIONALITY,
    [ADDRESS_DATE_OF_BIRTH]: DIRECTOR_DATE_OF_BIRTH,
    [ADDRESS_EMAIL]: DIRECTOR_EMAIL_ADDRESS,
    [ADDRESS_ADDITIONAL_NATIONALITIES]: DIRECTOR_ADDITIONAL_NATIONALITIES,
    [ADDRESS_COUNTRY_OF_BIRTH]: DIRECTOR_COUNTRY_OF_BIRTH,
    [PASSPORT_DOCUMENT]: DIRECTOR_PASSPORT_DOCUMENT,
  },
  [COMPANY_ULTIMATE_BENEFICIAL_OWNERS]: {
    _type: 'PERSON_ADDRESS',
    [ADDRESS_NATIONALITY]: BENEFICIAL_OWNER_NATIONALITY,
    [ADDRESS_DATE_OF_BIRTH]: BENEFICIAL_OWNER_DATE_OF_BIRTH,
    [ADDRESS_ADDITIONAL_NATIONALITIES]: BENEFICIAL_OWNER_ADDITIONAL_NATIONALITIES,
    [ADDRESS_COUNTRY_OF_BIRTH]: BENEFICIAL_OWNER_COUNTRY_OF_BIRTH,
    [PASSPORT_DOCUMENT]: BENEFICIAL_OWNER_POLITICALLY_EXPOSED_PASSPORT_DOCUMENT,
  },
}
